import { render, staticRenderFns } from "./AreasTable.vue?vue&type=template&id=ebce5720&"
import script from "./AreasTable.vue?vue&type=script&lang=js&"
export * from "./AreasTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports